module.exports = __webpack_public_path__ + "static/nhan_quan_31-4fc4430becf5957957628bbee66790f6.jpg";